import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-login-refresh",
  "use": "icon-login-refresh-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" fill=\"none\" id=\"icon-login-refresh\">\n  <path d=\"M24.5 13.9022C24.5 19.7552 19.799 24.5 14 24.5C8.201 24.5 3.5 19.7552 3.5 13.9022C3.5 8.04928 8.20103 3.30448 14 3.30448C17.1657 3.30448 20.0041 4.71847 21.9293 6.95483M21.9293 6.95483L21.3096 2.625M21.9293 6.95483H17.6797\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol